var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown--content--list"},[_vm._l((_vm.list),function(item,index){return _c('li',{key:item.index,attrs:{"data-index":index}},[((
        _vm.selectedApplicationName !== 'Alcohol app (Maxx)' 
        && (
          item.label === 'Issues'
          || item.label === 'Moments'
          || item.label === 'Situations'
          || item.label === 'MAXX'
        )
      )
      ||
      (
        _vm.selectedApplicationName !== 'Stopstone'
        && (
          item.label === 'Strategy'
          || item.label === 'Stopstone'
        )
      ))?_c('span',[_vm._v("\n      "+_vm._s(item.label)+"\n    ")]):_c('a',{attrs:{"href":item.to}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])])}),(_vm.list.length === 0)?_c('li',[_vm._v("No results found 😟")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }